import { motion } from 'framer-motion';
import { Plus, Minus } from '@phosphor-icons/react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger } from
'./ui/accordion';

const faqs = [
{
  question: 'Was ist eine schlüsselfertige Komplettsanierung?',
  answer: 'Bei einer schlüsselfertigen Komplettsanierung übernehmen wir die gesamte Projektleitung von der Planung bis zur Übergabe. Sie haben einen einzigen Ansprechpartner und müssen sich um nichts kümmern — wir koordinieren alle Gewerke und sorgen für termingerechte Fertigstellung.'
},
{
  question: 'Wie funktioniert die Festpreisgarantie?',
  answer: 'Nach der Bestandsaufnahme und Planung erhalten Sie von uns ein verbindliches Festpreisangebot. Dieser Preis ist fix — es gibt keine versteckten Kosten oder nachträglichen Aufschläge. So haben Sie volle Kostentransparenz und Planungssicherheit.'
},
{
  question: 'Welche Sanierungsarbeiten bieten Sie an?',
  answer: 'Wir bieten das komplette Spektrum: Fenster- und Fassadenarbeiten, Dachsanierung, Heizung und Sanitär, Elektrik, Innenausbau, Maler- und Bodenarbeiten sowie energetische Sanierungen. Alles aus einer Hand.'
},
{
  question: 'Wie lange dauert eine Komplettsanierung?',
  answer: 'Die Dauer hängt vom Umfang des Projekts ab. Eine durchschnittliche Komplettsanierung dauert zwischen 3 und 6 Monaten. Nach der Erstberatung erhalten Sie einen verbindlichen Zeitplan mit allen Meilensteinen.'
},
{
  question: 'Unterstützen Sie bei Fördermitteln?',
  answer: 'Ja, wir beraten Sie umfassend zu allen aktuellen Fördermöglichkeiten für energetische Sanierungen und helfen Ihnen bei der Antragstellung. So nutzen Sie alle verfügbaren Zuschüsse und Förderprogramme optimal.'
},
{
  question: 'Muss die Immobilie während der Sanierung leer stehen?',
  answer: 'Bei einer Komplettsanierung ist es in der Regel erforderlich, dass die Immobilie während der Bauphase nicht bewohnt wird. Bei Teilmodernisierungen ist eine Bewohnung je nach Umfang der Arbeiten möglich. Dies klären wir individuell in der Beratung.'
}];


const FAQSection = () => {
  return (
    <section className="py-24 md:py-32 bg-dark-secondary" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12">

          <span className="text-gold font-sans text-sm uppercase tracking-[0.2em] mb-4 block">
            Häufige Fragen
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl text-white mb-6">
            Das sollten Sie wissen
          </h2>
        </motion.div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) =>
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.05 }}>

              <AccordionItem
              value={`item-${index}`}
              className="glass-card border-white/10 px-6 data-[state=open]:border-gold/30"
              data-testid={`faq-item-${index}`}>

                <AccordionTrigger className="text-left py-5 hover:no-underline group">
                  <span className="font-serif text-lg text-white group-hover:text-gold transition-colors pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-white/60 text-sm leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          )}
        </Accordion>

        {/* Additional Help */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-12">

          <p className="text-white/50 text-sm mb-4">
            Noch Fragen? Wir sind für Sie da.
          </p>
          <a
            href="tel:+4921293758775"
            className="text-gold hover:text-gold-light transition-colors text-lg"
            data-testid="faq-phone-link">
            02129/375877-5
          </a>
        </motion.div>
      </div>
    </section>);

};

export default FAQSection;